import { HTTP, HTTPS, MAILTO, TEL } from '../../constants';
import isAbsolutePath from './is-absolute-path';
const sanitizeUrlForExternalLink = url => {
  if (isAbsolutePath(url) && !url.includes(HTTP) && !url.includes(HTTPS) && !url.includes(MAILTO) && !url.includes(TEL)) return `http://${url}`;
  return url;
};
export default sanitizeUrlForExternalLink;
//# sourceMappingURL=sanitize-url-for-external-link.js.map